import axios from 'axios';
import { API_CONFIG, AUTH_CONFIG } from './config';

// Create axios instance
const instance = axios.create({
  baseURL: API_CONFIG.BASE_URL,
  timeout: API_CONFIG.TIMEOUT,
  headers: {
    'Content-Type': 'application/json',
  }
});

// Add request interceptor
instance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem(AUTH_CONFIG.TOKEN_KEY);
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor
instance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // If the error is due to an expired token
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        // Get refresh token from localStorage
        const refreshToken = localStorage.getItem('refresh_token');
        if (!refreshToken) {
          throw new Error('No refresh token available');
        }

        // Create a new axios instance for refresh to avoid infinite loops
        const refreshInstance = axios.create({
          baseURL: API_CONFIG.BASE_URL,
          timeout: API_CONFIG.TIMEOUT,
          headers: {
            'Content-Type': 'application/json'
          }
        });

        const response = await refreshInstance.post('/api/v1/auth/refresh', {
          refresh_token: refreshToken
        });
        const { access_token, refresh_token } = response.data;
        localStorage.setItem(AUTH_CONFIG.TOKEN_KEY, access_token);
        // Update refresh token if provided (token rotation)
        if (refresh_token) {
          localStorage.setItem('refresh_token', refresh_token);
        }

        // Retry the original request
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return instance(originalRequest);
      } catch (refreshError) {
        console.error('Refresh token failed:', refreshError);
        // If refresh token fails, logout user
        localStorage.removeItem(AUTH_CONFIG.TOKEN_KEY);
        localStorage.removeItem('refresh_token');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default instance; 